<template></template>
<script>
export default {
  created () {
    this.setFilterRanges()
  },

  methods: {
    setFilterRanges () {
      const livingOptionsDwellings = this.$store.getters['property/livingOptionsDwellings']
      
      if (livingOptionsDwellings.length) {
        let priceRanges = []
        let priceMinVal = _.minBy(livingOptionsDwellings, 'price')
        let priceMaxVal = _.maxBy(livingOptionsDwellings, 'price')

        if (priceMinVal) {
          priceMinVal = priceMinVal.price / 1000
          priceRanges.push(Math.floor(priceMinVal / 50) * 50)
        }

        if (priceMaxVal) {
          priceMaxVal = priceMaxVal.price / 1000
          priceRanges.push(Math.ceil(priceMaxVal / 50) * 50)
        }

        let sizeRanges = []
        let sizeMinVal = _.minBy(livingOptionsDwellings, 'size')
        let sizeMaxVal = _.maxBy(livingOptionsDwellings, 'size')

        if (sizeMinVal) {
          sizeMinVal = sizeMinVal.size
          sizeRanges.push(Math.floor(sizeMinVal / 25) * 25)
        }

        if (sizeMaxVal) {
          sizeMaxVal = sizeMaxVal.size
          sizeRanges.push(Math.ceil(sizeMaxVal / 25) * 25)
        }

        // set filter ranges
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputPriceRange: priceRanges,
          inputDwellingSizeRange: sizeRanges,
          inputBeds: false,
          inputBaths: false,
          inputCars: false,
          inputLotNumber: '',
          inputBuilder: ''
        })
      }
    },
  }
}
</script>
